/**
 * Ba đích có thật của cổng tưởng niệm, không hơn (Spec §5.3).
 *
 * Ở file riêng chứ không nằm trong `PublicPortalLayout.tsx`: file kia export component, mà export
 * thêm hằng thường từ cùng module sẽ phá Fast Refresh
 * (`react-refresh/only-export-components`) — repo chạy `eslint --max-warnings=0` nên cảnh báo đó
 * là lỗi build.
 *
 * Thêm một hằng ở đây là dựng một màn không tồn tại; bớt một hằng là chặn một lối vào duy nhất.
 *
 * Slug `nt-demo-001` chỉ sống trong URL: Spec §6.3 cấm hiển thị nó như một cái tên, nên nó không
 * được xuất hiện ở bất kỳ chuỗi chữ nào của khung.
 */
export const PORTAL_HOME_PATH = "/";
export const SCENE_PATH = "/public/cemeteries/nt-demo-001/3d";
export const MARTYRS_SEARCH_PATH = "/danh-sach-liet-si";
export const STAFF_LOGIN_PATH = "/martyrs";
